module.exports = __webpack_public_path__ + "static/media/Calendar.c26dc8c8.svg";